import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import { useTranslation } from 'react-i18next';
import { useNavCounts } from 'context/NavCountsContext';
import mercadoLibreLogo from 'assets/img/logos/mercadolibre45470890.png';

const ICON_IMAGES = {
  mercadolibre: { src: mercadoLibreLogo, alt: 'Mercado Libre' }
};

const NavbarVerticalMenuItem = ({ route }) => {
  const { t } = useTranslation();
  const navCounts = useNavCounts();
  const liveCount = route.navCountKey ? (navCounts[route.navCountKey] || 0) : 0;

  return (
    <Flex alignItems="center" className={route.disabled ? 'opacity-50' : ''}>
      {route.iconImage && ICON_IMAGES[route.iconImage] ? (
        <span className="nav-link-icon d-flex align-items-center">
          <img
            src={ICON_IMAGES[route.iconImage].src}
            alt={ICON_IMAGES[route.iconImage].alt}
            style={{ width: 16, height: 16, objectFit: 'contain' }}
          />
        </span>
      ) : route.icon ? (
        <span className="nav-link-icon">
          <FontAwesomeIcon icon={route.icon} />
        </span>
      ) : null}
      <span className="nav-link-text ps-1">
        {route.rawLabel ? route.name : t(route.name)}
      </span>
      {liveCount > 0 && (
        <SoftBadge pill bg="danger" className="ms-2">
          {liveCount}
        </SoftBadge>
      )}
      {liveCount === 0 && route.badge && (
        <SoftBadge pill bg={route.badge.type} className="ms-2">
          {route.badge.text.startsWith('MAIN.') ? t(route.badge.text) : route.badge.text}
        </SoftBadge>
      )}
    </Flex>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem);
